import type { AmmTooltipData } from "@/components/app/trade/amm/amm-summary-graph";
import CoinPriceFormatter from "@/components/shared/coin-price-formatter";
import { FOCUS_TOKEN_DISPLAY_NAME } from "@/utils/constants";
import { focusToUsd, formatDecimalValue } from "@/utils/currency";

const AmmSummaryGraphTooltip = ({
  data,
  coinUsername,
  focusExchangeRate,
}: {
  data: AmmTooltipData;
  coinUsername: string;
  focusExchangeRate: number;
}) => {
  if (!data) return null;

  return (
    <div
      className="
        pointer-events-none mx-4 w-[280px] rounded-xl border bg-accent px-4
        text-sm text-muted-foreground
      "
    >
      <div
        className="
          unforce-radius grid grid-cols-[30%_65%] items-center gap-[5%] border-b
          py-2
        "
      >
        <div className="text-sm font-medium text-muted">
          Token
          <br />
          Price
        </div>
        <div className="flex flex-col items-end gap-1">
          <div className="flex items-center gap-1">
            <CoinPriceFormatter
              price={data.priceInUsd}
              className="font-mono text-sm text-green-500"
            />
            <span className="text-xxs text-muted">USD</span>
          </div>
          <div className="flex items-center gap-1 font-mono text-foreground">
            <CoinPriceFormatter
              isUsd={false}
              price={data.priceInQuoteCurrency}
              className="text-xs"
            />
            <span className="text-xs text-muted">
              {FOCUS_TOKEN_DISPLAY_NAME}
            </span>
          </div>
        </div>
      </div>
      <div
        className="
          unforce-radius grid grid-cols-[30%_65%] items-center gap-[5%] border-b
          py-2
        "
      >
        <div className="text-sm font-medium text-muted">
          Tokens
          <br />
          Sold
        </div>
        <div className="flex flex-col items-end gap-1">
          <span className="font-mono text-sm text-foreground">
            {formatDecimalValue(data.totalTokensSold)}
          </span>
          <span className="font-mono text-xs text-muted">${coinUsername}</span>
        </div>
      </div>
      <div
        className="
          unforce-radius grid grid-cols-[30%_65%] items-center gap-[5%] border-b
          py-2
        "
      >
        <div className="text-sm font-medium text-muted">
          Amount
          <br />
          Purchased
        </div>
        <div className="flex flex-col items-end gap-1">
          <div className="flex items-center gap-1">
            <CoinPriceFormatter
              price={focusToUsd(data.totalTokensPurchased, focusExchangeRate)}
              className="font-mono text-sm text-green-500"
            />
            <span className="text-xs text-muted">USD</span>
          </div>
          <div className="flex items-center gap-1 font-mono text-foreground">
            <CoinPriceFormatter
              isUsd={false}
              price={data.totalTokensPurchased}
              className="text-xs"
            />
            <span className="text-xs text-muted">
              {FOCUS_TOKEN_DISPLAY_NAME}
            </span>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-[30%_65%] items-center gap-[5%] py-2">
        <div className="text-sm font-medium text-muted">Average Price</div>
        <div className="flex flex-col items-end gap-1">
          <div className="flex items-center gap-1">
            <CoinPriceFormatter
              price={focusToUsd(
                data.totalTokensPurchased / data.totalTokensSold,
                focusExchangeRate,
              )}
              className="font-mono text-sm text-green-500"
            />
            <span className="text-xs text-muted">USD</span>
          </div>
          <div className="flex items-center gap-1 font-mono text-foreground">
            <CoinPriceFormatter
              isUsd={false}
              price={data.totalTokensPurchased / data.totalTokensSold}
              className="text-xs"
            />
            <span className="text-xs text-muted">
              {FOCUS_TOKEN_DISPLAY_NAME}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmmSummaryGraphTooltip;
